export default "__VITE_ASSET__636402dd__"